import React, {createContext, useContext, useState} from 'react';
import _ from 'lodash';
import {NodeTypes} from '../constants/nodeTypes';
import {circuitTemplate} from '../constants/jsonTemplates';
import {updateNestedObject} from '../components/treeView/utils/treeUtils';
import {useTree} from './TreeContext';

const CircuitFormContext = createContext();

export const CircuitFormProvider = ({children}) => {
  const {treeData, selectedNode, updateTreeData, setEditNodeModalOpen, getNewChild} = useTree();
  const [circuitFormData, setCircuitFormData] = useState(_.cloneDeep(circuitTemplate));
  const [evChargerFormData, setEvChargerFormData] = useState({});
  const [advancedMode, setAdvancedMode] = useState(false);

  const saveCircuit = () => {
    const newTreeData = _.cloneDeep(treeData);
    const conditionFn = (obj) => obj.name === selectedNode;
    const updateFn = (obj) => {
      const initialType = obj.type;
      obj.type = NodeTypes.CIRCUIT;
      obj.attributes = circuitFormData;
      if (initialType === NodeTypes.CIRCUIT) return;
      obj.children = [{name: `${selectedNode},0`, type: NodeTypes.ADDNODE}];
    };
    updateNestedObject(newTreeData, conditionFn, updateFn, getNewChild());
    updateTreeData(newTreeData);
    setCircuitFormData(circuitTemplate);
    setEditNodeModalOpen(false);
  };

  const saveEvCharger = (evChargerType) => {
    const newTreeData = _.cloneDeep(treeData);
    const conditionFn = (obj) => obj.name === selectedNode;
    const updateFn = (obj) => {
      obj.type = NodeTypes.EVCHARGER;
      obj.attributes = {};
      obj.attributes[evChargerType] = evChargerFormData;
    };
    updateNestedObject(newTreeData, conditionFn, updateFn, getNewChild());
    updateTreeData(newTreeData);
    setEditNodeModalOpen(false);
  };

  return (
    <CircuitFormContext.Provider value={{
      circuitFormData,
      setCircuitFormData,
      evChargerFormData,
      setEvChargerFormData,
      advancedMode,
      setAdvancedMode,
      saveCircuit,
      saveEvCharger,
    }}>
      {children}
    </CircuitFormContext.Provider>
  );
};

export const useCircuitForm = () => {
  const context = useContext(CircuitFormContext);
  if (!context) throw new Error('useCircuitForm must be used within a CircuitFormProvider');
  return context;
};

